module.exports = __webpack_public_path__ + "img/gifts-solid.de4a19cd.svg";